export const apiUrl = process.env.REACT_APP_API_URL;
export const uploadsUrl = process.env.REACT_APP_UPLOADS_URL;

export const companyReqId = process.env.REACT_APP_COMPANY_REQUISITES_ID;

export const appDefaultLanguage = "en";
export const serverTimeZone = "Asia/Dushanbe";

/**
 * Карта "валюта → адрес фронта, который в ней считает". В .env кладётся JSON:
 *   REACT_APP_CURRENCY_HOSTS={"USD":"https://flyashgabat.com","RUB":"https://ru.flyashgabat.com"}
 * Своя валюта приходит с бэка (getRequisites), поэтому отдельной переменной для неё нет:
 * выбор другой валюты в шапке — это переход на её домен.
 * Хост без схемы дополняем https://, чтобы короткая запись тоже работала.
 * Сломанный JSON гасим предупреждением: фронт должен продолжить работать по-старому,
 * а не упасть на старте из-за опечатки в .env.
 */
const parseCurrencyHosts = () => {
  const raw = (process.env.REACT_APP_CURRENCY_HOSTS || "").trim();

  if (!raw) return {};

  let parsed;

  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    console.warn("REACT_APP_CURRENCY_HOSTS не разобрался как JSON — переключение валют по доменам выключено");

    return {};
  }

  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

  return Object.entries(parsed).reduce((acc, [currency, host]) => {
    if (typeof host !== "string" || !host.trim()) return acc;

    const address = host.trim().replace(/\/+$/, "");

    acc[currency.trim().toUpperCase()] = /^https?:\/\//i.test(address) ? address : `https://${address}`;

    return acc;
  }, {});
};

export const currencyHosts = parseCurrencyHosts();

export const formatDateTime = "YYYY-MM-DD HH:mm:ss";
export const webTransferTimeFormat = "DD.MM.YYYY HH:mm";

export const friendlyCountriesCodes = ["RU", "AM", "BY", "АЦ", "KZ", "ЮО", "KG"];

export const phoneMask = rawValue => {
  const digits = rawValue.replace(/[^\d]/g, "");

  // +998 (XX) XXX-XX-XX — Uzbekistan
  if (digits.startsWith("998")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +992 (XX) XXX-XX-XX — Tajikistan
  if (digits.startsWith("992")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +996 (XXX) XX-XX-XX — Kyrgyzstan
  if (digits.startsWith("996")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +993 (XX) XX-XX-XX — Turkmenistan
  if (digits.startsWith("993")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, ")", " ", /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +994 (XX) XXX-XX-XX — Azerbaijan
  if (digits.startsWith("994")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +995 (XXX) XX-XX-XX — Georgia
  if (digits.startsWith("995")) {
    return ["+", /\d/, /\d/, /\d/, " ", "(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +90 (XXX) XXX-XX-XX — Turkey
  if (digits.startsWith("90")) {
    return ["+", /\d/, /\d/, " ", "(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +7 (XXX) XXX-XX-XX — Russia, Kazakhstan
  if (digits.startsWith("7")) {
    return ["+", /\d/, " ", "(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/];
  }

  // +1 (XXX) XXX-XXXX — USA, Canada
  if (digits.startsWith("1")) {
    return ["+", /\d/, " ", "(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
  }

  // Generic international format: +XXX XXX XXX XXX (up to 15 digits)
  const mask = ["+"];
  const len = Math.min(Math.max(digits.length + 1, 11), 15);
  for (let i = 0; i < len; i++) {
    if (i > 0 && i % 3 === 0) mask.push(" ");
    mask.push(/\d/);
  }
  return mask;
};
